<script>
    import Footer from "./sections/Footer.svelte";
    import Purchase from "./sections/Purchase.svelte";
    import Books from "./sections/Books.svelte";
    import AppInfo from "./sections/AppInfo.svelte";
    import VideoChannel from "./sections/VideoChannel.svelte";
    import Channel from "./sections/Channel.svelte";
</script>
<div style="width: 375px; position:relative;">
<Purchase />
<Books />
<AppInfo />
<Channel />
<VideoChannel />
<Footer />
</div>
